// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {SimUser} from "@models";

/**
 * User Image Component
 * Displays user image or initials when no image is available
 *
 * ```html
 * <sim-user-image-initials>
 *     [user]="user_obj"
 * </sim-user-image-initials> ```
 * <example-url>../assets/examples/example_component_initials_1.PNG</example-url>
 * <example-url>../assets/examples/example_component_initials_2.PNG</example-url>
 */
@Component({
	selector: "sim-user-image-initials",
	templateUrl: "./user-image-initials.component.html",
	styleUrls: ["./user-image-initials.component.scss"],
	standalone: false,
})
export class UserImageInitialsComponent implements OnInit {
	/** User **/
	@Input() user: SimUser = null;
	/** imageUrl **/
	@Input() imageUrl: string;
	/** ts **/
	@Input() td;
	/** justImage Input **/
	@Input() justImage;
	/** bigImage Input **/
	@Input() bigImage;
	/** smalImage Input **/
	@Input() smallImage;
	/** UserImageByClasses Input **/
	@Input() userImageClasses: String;

	/**
	 *
	 */
	constructor() {}

	/**
	 *
	 */
	ngOnInit() {}
}
